import { jsx as i } from "react/jsx-runtime";
import m from "../IconAnimated.js";
import { IconContainer as u } from "../IconContainer.js";
import { useRef as s, useEffect as f, memo as p } from "react";
import { useEventResolver as C } from "@biron-data/react-contexts";
import "../useResizeDetector-1ae5f4fb.js";
const l = () => {
}, k = (n, o, e) => {
  const t = (/* @__PURE__ */ new Date()).getTime(), r = () => {
    if ((/* @__PURE__ */ new Date()).getTime() - t >= o) {
      n == null || n(), e(l);
      return;
    }
    const a = requestAnimationFrame(r);
    e(() => cancelAnimationFrame(a));
  }, c = requestAnimationFrame(r);
  e(() => cancelAnimationFrame(c));
}, d = () => {
  const n = s(l), o = (t) => n.current = t, e = () => n.current();
  return f(() => e, []), [o, e];
}, D = ({
  onClick: n,
  onDoubleClick: o,
  delay: e = 300
}) => {
  const [t, r] = d();
  return [() => {
    r(), k(n, e, t);
  }, () => {
    r(), o == null || o();
  }];
}, g = p(({
  onCopy: n,
  handleDuplicate: o,
  GACategory: e
}) => {
  const t = C(), [r, c] = D({
    onClick: () => {
      e && t.capture({
        category: e,
        action: "copy"
      }), n();
    },
    onDoubleClick: () => {
      e && t.capture({
        category: e,
        action: "duplicate"
      }), o();
    }
  });
  return /* @__PURE__ */ i(u, { clickable: !0, hoverColor: "var(--primary-light)", containerSize: 28, children: /* @__PURE__ */ i(
    m,
    {
      onClick: r,
      onDoubleClick: c
    }
  ) });
});
export {
  g as default
};
//# sourceMappingURL=CopyDuplicate.js.map
